import { Button, Radio } from '@fagmobler/ui';
import { Popover } from '@headlessui/react';
import { ArrowsUpDownIcon } from '@heroicons/react/24/outline';
import { useSortBy } from 'react-instantsearch-hooks-web';

type SortingButtonWithPopoverProps = {
  isActive?: boolean;
};

export const SortingButtonWithPopover = ({
  isActive,
}: SortingButtonWithPopoverProps) => {
  const { options, refine, canRefine, initialIndex, currentRefinement } =
    useSortBy({
      items: [
        { label: 'Relevans', value: 'try_fagmobler' },
        { label: 'Pris: Lavest til høyest', value: 'try_fagmobler_price_asc' },
        { label: 'Pris: Høyest til lavest', value: 'try_fagmobler_price_desc' },
      ],
    });

  return (
    <Popover title="Sorter etter" className="relative">
      <Popover.Button as="div">
        <Button
          className="whitespace-nowrap block pr-3 w-full justify-center"
          type="button"
          Icon={ArrowsUpDownIcon}
          variant="outline"
        >
          <ArrowsUpDownIcon className="h-4 w-4 mr-2" />
          Sorter
        </Button>
      </Popover.Button>
      <Popover.Panel className="absolute z-10 bg-neutral-0 shadow p-5 min-w-fit mt-2">
        {options.map((option) => {
          return (
            <Radio
              label={option.label}
              name={option.value}
              value={option.value}
              key={option.value}
              checked={option.value === currentRefinement}
              onChange={() => refine(option.value)}
              className="mb-5 whitespace-nowrap"
              disabled={!canRefine}
            />
          );
        })}
      </Popover.Panel>
    </Popover>
  );
};

export default SortingButtonWithPopover;
